module.exports = __webpack_public_path__ + "img/@tmp_course_thumbnail_04.cc295c81.jpg";